<template>
  <TemplateOneTimeCode />
</template>

<script>
import TemplateOneTimeCode from "@/views/Templates/TicketStore/TemplateOneTimeCode";

export default {
  name: "OneTiemCode",

  components: {
    TemplateOneTimeCode: TemplateOneTimeCode,
  },
};
</script>
